import React, { useEffect, useState } from 'react';
import { useI18n } from '../contexts/I18nContext';

/**
 * Ticks every second so consumers re-render. Returns Date.now().
 * Auto-pauses when the tab is hidden — no point updating UI nobody sees.
 */
export const useNowTick = (intervalMs = 1000) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => {
      if (!document.hidden) setNow(Date.now());
    }, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
};

/**
 * Renders "Updated 12s ago" / "Updated 3m ago" / "Updated just now".
 * Pass `at` as a millisecond timestamp (or null while never-loaded).
 */
export default function LastUpdated({ at, testid }) {
  const { t } = useI18n();
  const now = useNowTick(1000);
  if (!at) return null;
  const deltaSec = Math.max(0, Math.floor((now - at) / 1000));
  let label;
  if (deltaSec < 5) {
    label = t('updated_just_now');
  } else if (deltaSec < 60) {
    label = t('updated_n_sec_ago').replace('{n}', deltaSec);
  } else {
    label = t('updated_n_min_ago').replace('{n}', Math.floor(deltaSec / 60));
  }
  return (
    <span data-testid={testid} className="text-[11px] text-ink-muted">
      {label}
    </span>
  );
}
